module.exports = __webpack_public_path__ + "static/media/3.20717cb0.jpg";